import { Route, Switch } from 'react-router';
import ViewDivisions from './view';
import EditDivision from './edit';
import CreateDivision from './create';

const Divisions = () => {
  return (
    <Switch>
      <Route exact path='/admin/divisions' component={ViewDivisions} />
      <Route exact path='/admin/divisions/new' component={CreateDivision} />
      <Route exact path='/admin/divisions/:id' component={EditDivision} />
    </Switch>
  );
};

export default Divisions;
